import { TForumMessage } from "../types";
import { get, post } from "./axiosClient";

type SaveForumMessageProps = {
    message: TForumMessage,
    forum: string,
    token?: string
}

interface SaveForumMessageResponse {
    success: boolean,
    errorMessage?: string
}

export const saveForumMessage = async ({ message, forum, token }: SaveForumMessageProps): Promise<SaveForumMessageResponse> => {
    return await post({
        data: {Message: message.Message, Author: message.Author},
        params: { forum: forum },
        path: 'forum',
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { success: true }
        } else {
            return {
                errorMessage: res.data,
                success: false
            }
        }
    });
}

type GetForumMessageProps = {
    forum: string,
    token?: string,
}

interface GetForumMessageResponse {
    messages?: TForumMessage[],
    errorMessage?: string,
}

export const getForumMessages = async ({ forum, token }: GetForumMessageProps): Promise<GetForumMessageResponse> => {
    return await get({
        params: { forum: forum },
        path: 'forum',
        token
    }).then((res) => {
        if (res.status === 200) {
            return { messages: res.data }
        } else {
            return { errorMessage: res.data }
        }
    });
}